import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "menuScrollProps", "maxMenuHeight"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React, { forwardRef, useRef, useImperativeHandle } from 'react';
import { useMenusScroll } from './useMenusScroll';
import { StyledMenuList } from './menuListStyles';
// EmbersMenuList takes a list of EmbersMenuItems as children.
//  It wraps them and styles them, and handles scrolling.
//  It is used by the EmbersMenu and is the standard way embers has of
//  building a menu.

var BaseMenuList = function BaseMenuList(_ref, ref) {
  var children = _ref.children,
    menuScrollProps = _ref.menuScrollProps,
    maxMenuHeight = _ref.maxMenuHeight,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var refMenuList = useRef(null);
  useMenusScroll(refMenuList, maxMenuHeight ? {
    removeScroll: true
  } : menuScrollProps);
  useImperativeHandle(ref, function () {
    return refMenuList.current;
  });
  var heightStyle = {};
  if (maxMenuHeight) {
    heightStyle.maxHeight = typeof maxMenuHeight === 'number' ? "".concat(maxMenuHeight, "px") : maxMenuHeight;
  }
  return /*#__PURE__*/React.createElement(StyledMenuList, _extends({
    role: "listbox"
  }, otherProps, {
    style: _objectSpread(_objectSpread({}, heightStyle), otherProps.style || {}),
    ref: refMenuList
  }), children);
};
export var EmbersMenuList = /*#__PURE__*/forwardRef(BaseMenuList);